"use client"

import type { ChainIdentifier } from "@opensea/graphql"
import { useEffect, useState } from "react"
import { useIsSmartContractWallet } from "../../flow/hooks/useIsSmartContractWallet"
import { useChainIdentifier } from "../../polychain/hooks"

type Props = {
  destinationChain: ChainIdentifier
}

export const useSmartContractWalletWarningModal = ({
  destinationChain,
}: Props) => {
  const isSmartContractWallet = useIsSmartContractWallet()
  const activeChain = useChainIdentifier()
  const isCrossChain = activeChain !== destinationChain

  const [
    smartContractWalletWarningModalOpen,
    setSmartContractWalletWarningModalOpen,
  ] = useState(false)

  useEffect(() => {
    if (isSmartContractWallet && isCrossChain) {
      setSmartContractWalletWarningModalOpen(true)
    }
  }, [isSmartContractWallet, isCrossChain])

  return {
    smartContractWalletWarningModalOpen,
    setSmartContractWalletWarningModalOpen,
  }
}
